import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StatisticsQueryService } from '@app/core';
import { SectionHeaderComponent, TimeAgoPipe } from '@app/widgets';
import { TuiAppearance, TuiIcon } from '@taiga-ui/core';
import { TuiPulse } from '@taiga-ui/kit';
import { CountUpModule } from 'ngx-countup';

@Component({
  selector: 'app-live-updates-statistics-section',
  imports: [
    CountUpModule,
    SectionHeaderComponent,
    TuiAppearance,
    TuiIcon,
    TuiPulse,
    TimeAgoPipe,
  ],
  templateUrl: './live-updates-statistics-section.component.html',
  styleUrl: './live-updates-statistics-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveUpdatesStatisticsSectionComponent {
  protected readonly statistics = this.statisticsQueryService.queryStatistics();

  constructor(
    private readonly statisticsQueryService: StatisticsQueryService,
  ) {}
}
